module.exports = __webpack_public_path__ + "img/avatar1.0a1b351f.png";